import type { TFunction } from 'i18next';
import { toast } from '../../store/toastStore';
import { runQuickCreate } from '../quickcreate/quickCreateStore';

/**
 * FQ-062 (Q-176) + D-341 (6): under a minute nothing was recorded. The note carries a link "רוצה לרשום שעות בדיעבד?
 * הוספת לוג" that opens the work-log form (today's date is its default).
 */
export function toastUnderMinute(t: TFunction): void {
  toast('info', t('timer.underMinuteNotLogged'), {
    action: { label: t('timer.underMinuteAddLog'), onClick: () => runQuickCreate('worklog') },
    duration: 9000,
  });
}
